import { createEnvelopeSource } from './create-envelope-source';

/**
 * RPP coupons-issued KPI source. Pure config over the standardized envelope
 * (`GET /analytics/coupons/issued-rpp`): one scalar count of promotion-grant
 * rows on RPP promotions created in the period, plus a `businessUnit` and a
 * `province` breakdown of it.
 *
 * The issuance half of the RPP coupon funnel, and the mirror of
 * `coupon-redeemed-rpp`: same window convention, same RPP-registration province
 * source, so `couponsIssuedRpp` and `couponsRedeemedRpp` line up region by
 * region and can be read as one funnel.
 *
 * `coupon-issued`'s `couponsIssued` counts every promotion and attributes
 * province from the app account instead. The two never sum and neither nests
 * in the other: this count keeps coupons released unredeemed at expiry, which
 * `couponsIssued` excludes, while `couponsIssued` covers non-RPP promotions
 * this metric excludes. Their `UNKNOWN` rows also do not mean the same thing
 * (here it is always 0, because a grant with no RPP registration is excluded
 * rather than bucketed).
 *
 * Total-only: the endpoint declares `capabilities.daily=false`, so no `line`
 * form here.
 */
export const couponIssuedRppSource = createEnvelopeSource({
    label: 'RPP coupons issued',
    endpoint: 'analytics/coupons/issued-rpp',
    metrics: [
        {
            id: 'couponsIssuedRpp',
            label: 'RPP coupons issued',
            type: 'scalar',
        },
    ],
    forms: ['number', 'bars', 'pie'],
    regionGrain: 'province',
});
